import React from 'react';
import { Button } from 'takeat-design-system-ui-kit';
import {
  PromoCardContainer,
  PromoTitle,
  PromoSubtitle,
  PromoSection,
  PromoSectionTitle,
  PromoList,
  PromoListItem,
  PromoCTA,
  PromoCTAText,
} from './styles';
import useWhatsappStore from '~/store/whatsappStore';

const WHATSAPP_LINK =
  'https://api.whatsapp.com/send/?phone=5527998338296&text=Ol%C3%A1%2C+gostaria+de+saber+mais+sobre+o+Agente+de+IA+para+WhatsApp+que+vi+no+sistema+da+Takeat.+Pode+me+ajudar%3F&type=phone_number&app_absent=0';

export default function ChefBotPromo() {
  const { planType } = useWhatsappStore();

  return (
    <div style={{ marginTop: '16px' }}>
      <PromoCardContainer>
        <div>
          <PromoTitle>
            Inteligência Artificial - Automação para WhatsApp
          </PromoTitle>
          <PromoSubtitle style={{ marginTop: '8px' }}>
            Responda seus clientes 24h por dia e aumente suas vendas
            automaticamente
          </PromoSubtitle>
        </div>

        <PromoSection>
          <PromoSectionTitle>Como funciona?</PromoSectionTitle>
          <PromoList>
            <PromoListItem>
              O cliente envia mensagem no seu Whatsapp
            </PromoListItem>
            <PromoListItem>
              Nossa Inteligência Artificial responde de forma inteligente e
              natural, com base nas informações da sua loja e seu cardápio
            </PromoListItem>
            <PromoListItem>
              Você pode assumir a conversa a qualquer momento
            </PromoListItem>
          </PromoList>
        </PromoSection>

        <PromoSection>
          <PromoSectionTitle>Resultados para o seu negócio</PromoSectionTitle>
          <PromoList>
            <PromoListItem>
              Mais clientes atendidos em menos tempo
            </PromoListItem>
            <PromoListItem>
              Redução de filas e esperas no atendimento
            </PromoListItem>
          </PromoList>
        </PromoSection>

        {planType !== 'AI_AGENTS' && (
          <PromoCTA>
            <PromoCTAText>
              Ative agora mesmo nossa inteligência artificial para WhatsApp e
              transforme seu atendimento
            </PromoCTAText>
            <Button
              color="primary"
              onClick={() => window.open(WHATSAPP_LINK, '_blank')}
              style={{ minWidth: '200px' }}
            >
              Quero ativar
            </Button>
          </PromoCTA>
        )}
      </PromoCardContainer>
    </div>
  );
}
